/* eslint-disable import/prefer-default-export */
export const coursesConstants = {
  GET_COURSES_REQUEST: 'COURSES_GET_COURSES_REQUEST',
  GET_COURSES_SUCCESS: 'COURSES_GET_COURSES_SUCCESS',
  GET_COURSES_FAILURE: 'COURSES_GET_COURSES_FAILURE',

  SET_COURSES: 'COURSES_SET_COURSES',
  UNSET_COURSES: 'COURSES_UNSET_COURSES',

};
